import { ApiResponse } from "core/api/http/httpTypes";
import {
  ApiBreakdown,
  ApiProject,
  ProjectType,
} from "../model/types/projects.types";
import { httpClient } from "core/api/http/httpClient";

export const projectsApi = {
  list(params: {
    page: number;
    limit: number;
    search?: string;
    tree?: boolean;
  }) {
    return httpClient.get<ApiResponse<ApiProject[]>>("/projects", {
      params: {
        page: params.page,
        limit: params.limit,
        search: params.search?.trim() || undefined,
        tree:
          params.tree !== undefined
            ? params.tree
              ? "true"
              : "false"
            : undefined,
      },
    });
  },

  getById(projectId: number) {
    return httpClient.get<ApiResponse<ApiProject>>(`/projects/${projectId}`);
  },

  getTree(projectId: number) {
    return httpClient.get<ApiProject>(`/projects/${projectId}/tree`);
  },

  getByDirector(collaboradorId: number) {
    return httpClient.get<ApiResponse<ApiProject[]>>(
      `/projects/director/${collaboradorId}`,
    );
  },

  getProjectsStage() {
    return httpClient.get<ApiBreakdown[]>("/projects/stage");
  },

  getProjectsType() {
    return httpClient.get<ProjectType[]>("/projects/type");
  },
};
